import { LinkedinIcon, FacebookIcon, GoogleIcon, bankidcolor, } from "../components/images/svg/icons";

export const socialLogins = [
    {
        key: "bankid",
        icon: bankidcolor,
        alt: "BankID",
        label: "REGISTRATION_BANK_ID",
    },
    // {
    //     key: "google",
    //     icon: GoogleIcon,
    //     alt: "Google",
    //     label: "REGISTRATION_GOOGLE",
    // },
    // {
    //     key: "facebook",
    //     icon: FacebookIcon,
    //     alt: "Facebook",
    //     label: "REGISTRATION_FACEBOOK",
    // },
    // {
    //     key: "linkedin",
    //     icon: LinkedinIcon,
    //     alt: "LinkedIn",
    //     label: "REGISTRATION_LINKEDIN",
    // },
];
